module.exports = __webpack_public_path__ + "static/media/icon-circle-wechat.a66fcdfb.svg";